'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactstrap = require('reactstrap');

var _AutocompleteField = require('./AutocompleteField');

var _AutocompleteField2 = _interopRequireDefault(_AutocompleteField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * State suggest
 *
 * Field který automaticky dotahuje data z api a posílá jej do autocomplete
 */
var StateSuggestField = function (_React$Component) {
    (0, _inherits3.default)(StateSuggestField, _React$Component);

    function StateSuggestField() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, StateSuggestField);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = StateSuggestField.__proto__ || (0, _getPrototypeOf2.default)(StateSuggestField)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            data: null
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(StateSuggestField, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var apiCall = this.props.apiCall;

            apiCall().then(function (data) {
                _this2.setState({ data: data });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var data = this.state.data;
            var _props = this.props,
                apiCall = _props.apiCall,
                other = (0, _objectWithoutProperties3.default)(_props, ['apiCall']);


            if (!data) {
                return _react2.default.createElement(_reactstrap.Input, {
                    type: 'text',
                    disabled: true
                });
            }

            return _react2.default.createElement(_AutocompleteField2.default, (0, _extends3.default)({
                items: data
            }, other));
        }
    }]);
    return StateSuggestField;
}(_react2.default.Component);

StateSuggestField.PropTypes = {
    apiCall: _react2.default.PropTypes.func.isRequired
};
exports.default = StateSuggestField;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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